import React from "react";
import SEOLandingPage from "./SEOLandingPage";

const YamlViewerAndroid: React.FC = () => (
  <SEOLandingPage
    title="YAML Viewer for Android — View & Edit YAML Files on Your Phone | Cosmovex"
    metaDescription="YAML Viewer & Editor for Android. Syntax highlighting, real-time validation, YAML to JSON conversion, and clipboard auto-detect. View Kubernetes configs and Docker Compose files on mobile."
    ogTitle="YAML Viewer & Editor for Android"
    h1="YAML Viewer & Editor for Android"
    intro="Open YAML files, validate syntax, explore structure visually, and convert to JSON — all on your Android phone. Built for developers working with Kubernetes configs, Docker Compose, and Ansible playbooks."
    paragraphs={[
      "YAML is everywhere in modern development — Kubernetes configs, Docker Compose files, Ansible playbooks, CI/CD pipelines. But when you need to review or edit a YAML file on your phone, your options are usually a plain text editor with no validation. YAML Viewer & Editor changes that.",
      "Open any YAML file from device storage or paste YAML from your clipboard. The app instantly formats it with syntax highlighting, showing keys, values, and nested structures in distinct colors. The interactive tree view lets you expand and collapse nodes to explore complex YAML structures without scrolling through thousands of lines.",
      "Real-time validation catches syntax errors as you type, showing exact line numbers and descriptions. No more deploying a broken config because you missed an indentation error. Convert YAML to JSON with one tap — useful when working with APIs or tools that require JSON format.",
      "Clipboard auto-detect means you can copy a YAML snippet from anywhere and open the app to view it instantly. No manual pasting required. Everything runs offline — your configs never leave your device.",
    ]}
    features={[
      "Syntax highlighting for YAML structure",
      "Interactive tree view — expand/collapse nodes",
      "Real-time validation with line numbers",
      "One-tap YAML to JSON conversion",
      "Clipboard auto-detect for instant viewing",
      "Open YAML files from device storage",
      "Edit and save changes back",
      "Works fully offline",
      "Dark theme for developers",
      "Built for Kubernetes, Docker, Ansible configs",
    ]}
    playStoreUrl="https://play.google.com/store/apps/details?id=com.cosmovex.yamlvedit"
    icon="/images/yamlvedit.png"
    appName="YAML Viewer & Editor"
    accentColor="#A8720E"
    canonicalPath="/yaml-viewer-android"
  />
);

export default YamlViewerAndroid;
